var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import ___default from "lodash";
import { of } from "rxjs";
import "../models/index.js";
import { ApiErrorType } from "../models/ErrorModels.js";
import { produceLoadLoadingLoadedEpic } from "./ReduxObservablesEpicUtils.js";
import logger, { ErrorType } from "../services/logging/Logger.js";
import { WorkspaceMigrationStatusCodes } from "../models/IAsyncWrapper/WorkspaceMigrationModels.js";
import { MigrationErrorMessages } from "../constants/WorkspaceMigration.constants.js";
import { hasEntityBeenMigrated } from "./WorkspaceMigration.utils.js";
import EnvironmentService from "../services/EnvironmentService.js";
import { AsyncRequestStatus } from "../models/IAsyncWrapper/IAsyncWrapper.js";
import { getDefaultAsyncWrapperObj } from "../models/IAsyncWrapper/IAsyncWrapper.utils.js";
const loadResourcesUtils = (input) => {
  const reduxChange = (prevState, action) => {
    switch (action.type) {
      case `${input.actionPrefix}/RESET`:
        const actionCast0 = action;
        return __spreadValues({}, ___default.updateWith(
          ___default.clone(prevState),
          // @ts-ignore
          joinedKey(input.reduxKeyNested(actionCast0.payload)),
          (prevValue) => __spreadValues({}, getDefaultAsyncWrapperObj()),
          ___default.clone
        ));
      case `${input.actionPrefix}/LOADING`:
        const actionCast1 = action;
        return __spreadValues({}, ___default.updateWith(
          ___default.clone(prevState),
          // @ts-ignore
          joinedKey(input.reduxKeyNested(actionCast1.payload)),
          (prevValue) => __spreadProps(__spreadValues({}, prevValue), {
            status: AsyncRequestStatus.Pending
          }),
          ___default.clone
        ));
      case `${input.actionPrefix}/LOADED`:
        const actionCast2 = action;
        return __spreadValues({}, ___default.updateWith(
          ___default.clone(prevState),
          // @ts-ignore
          joinedKey(input.reduxKeyNested(actionCast2.payload)),
          (prevValue) => __spreadValues(__spreadValues({}, prevValue), actionCast2.outputPayloadAsync),
          ___default.clone
        ));
      default:
        return prevState;
    }
  };
  const actionCreators = {
    load: (inputPayload) => {
      return {
        type: `${input.actionPrefix}/LOAD`,
        payload: inputPayload
      };
    },
    loading: (inputPayload) => {
      return {
        type: `${input.actionPrefix}/LOADING`,
        payload: inputPayload
      };
    },
    loaded: (inputPayload, outputPayloadAsync) => {
      return {
        type: `${input.actionPrefix}/LOADED`,
        payload: inputPayload,
        outputPayloadAsync
      };
    },
    reset: (inputPayload) => {
      return {
        type: `${input.actionPrefix}/RESET`,
        payload: inputPayload
      };
    }
  };
  const epicArgs = {
    filterOnType: `${input.actionPrefix}/LOAD`,
    loadResource: (inputPayload, state) => {
      return input.loadResource(inputPayload, state);
    },
    skiploadDataTransform: true,
    loadingAction: (inputPayload) => actionCreators.loading(inputPayload),
    // @ts-ignore
    loadedAction: (response, payload, error, errorContext, state) => {
      var _a, _b, _c, _d, _e, _f, _g, _h, _i;
      if (input.onLoaded !== void 0) {
        const onLoadedResponse = input.onLoaded(response, payload, state);
        if (onLoadedResponse !== void 0) {
          if (onLoadedResponse.isSuccessful) {
            response.isSuccessful = () => true;
            response.getSuccessData = () => onLoadedResponse.data;
          }
        }
      }
      if (!response) {
        const outAsync = {
          data: null,
          status: AsyncRequestStatus.Failed,
          error: "No Response - error" + error,
          errorContext
        };
        return of(
          actionCreators.loaded(payload, outAsync),
          ...!!input.afterActionsOnFailure ? input.afterActionsOnFailure(payload, outAsync, state) : []
        );
      }
      if (!response.isSuccessful() && input.customError) {
        try {
          response.errorContext = __spreadValues(__spreadValues({}, response.errorContext), input.customError(payload, response));
        } catch (error2) {
          response.errorContext = __spreadProps(__spreadValues({}, response.errorContext), {
            displayError: "Failed to parse custom error property"
          });
        }
      }
      let outputPayloadAsync;
      if (EnvironmentService.wsplitEnableRedirects() && hasEntityBeenMigrated(response)) {
        const responseErrorContext = __spreadValues({
          statusCode: WorkspaceMigrationStatusCodes.MovedPermanently,
          displayError: MigrationErrorMessages.MovedPerminenty,
          type: ApiErrorType.MovedPermanently,
          correlationId: "No correlationId provided"
        }, response == null ? void 0 : response.errorContext);
        outputPayloadAsync = {
          data: input.onCompleteSuccess(response.getSuccessData(), payload),
          status: AsyncRequestStatus.Failed,
          error,
          errorContext: responseErrorContext
        };
      } else if (response.isSuccessful()) {
        outputPayloadAsync = {
          data: input.onCompleteSuccess(response.getSuccessData(), payload),
          status: AsyncRequestStatus.Completed,
          error: void 0,
          errorContext: void 0
        };
      } else {
        const error2 = (_b = (_a = response == null ? void 0 : response.errorContext) == null ? void 0 : _a.displayError) != null ? _b : "No error information is present";
        const responseErrorContext = response.errorContext;
        outputPayloadAsync = {
          data: null,
          status: AsyncRequestStatus.Failed,
          error: error2,
          errorContext: responseErrorContext
        };
        logger.error(error2, ErrorType.LoadedAction, {
          displayError: error2,
          correlationId: (responseErrorContext == null ? void 0 : responseErrorContext.correlationId) || (errorContext == null ? void 0 : errorContext.correlationId),
          responseErrorContext,
          errorContext,
          suppressPopup: true
        });
      }
      if (EnvironmentService.wsplitEnableRedirects() && !response.isSuccessful() && response.statusCode === WorkspaceMigrationStatusCodes.MethodNotAllowed) {
        const displayError = EnvironmentService.wsplitMethodNotAllowedText();
        outputPayloadAsync = {
          data: null,
          status: AsyncRequestStatus.Failed,
          error: (_e = (_d = (_c = response == null ? void 0 : response.errorContext) == null ? void 0 : _c.displayError) != null ? _d : displayError) != null ? _e : MigrationErrorMessages.MethodNotAllowed,
          errorContext: response.errorContext
        };
      }
      if (EnvironmentService.wsplitEnableRedirects() && !response.isSuccessful() && ((_f = response.errorContext) == null ? void 0 : _f.statusCode) === WorkspaceMigrationStatusCodes.NotAcceptable) {
        const displayError = EnvironmentService.wsplitNotAcceptableText();
        outputPayloadAsync = {
          data: null,
          status: AsyncRequestStatus.Failed,
          error: (_i = (_h = (_g = response == null ? void 0 : response.errorContext) == null ? void 0 : _g.displayError) != null ? _h : displayError) != null ? _i : MigrationErrorMessages.NotAcceptable,
          errorContext: response.errorContext
        };
      }
      return of(
        actionCreators.loaded(payload, outputPayloadAsync),
        ...response.isSuccessful() ? !!input.afterActionsOnSuccess ? input.afterActionsOnSuccess(payload, outputPayloadAsync.data, state) : [] : !!input.afterActionsOnFailure ? input.afterActionsOnFailure(payload, outputPayloadAsync, state) : []
      );
    },
    dontLoad: (payload, state) => {
      return !!input.dontLoad && input.dontLoad(payload, state);
    }
  };
  const epic = produceLoadLoadingLoadedEpic(epicArgs);
  return {
    reduxChange,
    actionCreators,
    epic
  };
};
const joinedKey = (reduxKeyNested) => {
  return reduxKeyNested.map((s) => `["${s}"]`).join("");
};
export {
  loadResourcesUtils
};
//# sourceMappingURL=LoadResourcesUtils.js.map
